/** Tokens visuais — extrato de inscrições (marca TNV) */
export const EXTRATO_ACCENT = "#F96030";

export const extratoToolbarSx = {
  mb: 2,
  p: 2,
  borderRadius: 2,
  bgcolor: "grey.50",
  border: "1px solid",
  borderColor: "grey.200",
  borderLeft: `4px solid ${EXTRATO_ACCENT}`,
};
